module.exports = __webpack_public_path__ + "static/media/Service_drop_wire_clamp.663245d4.webp";